import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import * as VueGoogleMaps from 'vue2-google-maps'
import JsonExcel from 'vue-json-excel'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

const options = {
  confirmButtonColor: '#2955c8',
  cancelButtonColor: '#5a6268',
}
Vue.use(VueSweetalert2, options)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// GOOGLE MAPS
/* Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC61cpaOppTlzzOi7ZImp0tmVJjLsHLvLI', // AIzaSyCwDZKJFOwbkqPttW3tR7BU_B2WsuIuu2Q
    libraries: 'places,drawing,visualization', // This is required if you use the Autocomplete plugin
  },
}) */

/* WINDOW GOOGLE MAPS */
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB1VEU-5uWFBH1NkfbnoA3Ttq68JFl-HHI', // AIzaSyB1VEU-5uWFBH1NkfbnoA3Ttq68JFl-HHI
    libraries: 'places,drawing,visualization', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  },
})

Vue.component('downloadExcel', JsonExcel)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
